import React, { useEffect } from "react";
import { TContainerStateProps } from "../../state/TContainerStateProps";
import { CRMListingPagePnl } from "../../components/CRMListingPagePnl/CRMListingPagePnl";
import { Background } from "../../components/BuildingBlocks/Background";
import { Text } from "../../components/BuildingBlocks/Text";
import { CRMSpacing } from "../../models/CRMSpacing";
import { CRMColors } from "../../models/CRMColors";

export const CRMListingPagePnlContainer = (props: TContainerStateProps): JSX.Element => {
    const listingId = props.state.routes.params.listingId;

    useEffect(
        () => {
            props.dispatch({ type: "LISTING_PAGE_GET_PNL", payload: listingId });
        },
        [listingId],
    );

    const pnlForm = props.state.forms.listing_page.listing_pnl;

    return (
        pnlForm.status === "loading"
            ? <Background padding={`${CRMSpacing.LARGE} ${CRMSpacing.LARGE}`}>
                <Text color={CRMColors.NEUTRAL_4}>Loading P&L…</Text>
            </Background>
            : <CRMListingPagePnl pnl={pnlForm.output} />
    );
};
